export function hexToRgbArray(hex) {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  return [r, g, b];
}

export function rgbaToPdfColor(rgba) {
  if (typeof rgba !== 'string') {
    return {
      C: [0, 0, 0],
      CA: 1,
    };
  }

  const match = rgba.match(
    /rgba?\(\s*(\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\s*\)/
  );

  if (!match) {
    return {
      C: [0, 0, 0],
      CA: 1,
    };
  }

  const r = Number(match[1]) / 255;
  const g = Number(match[2]) / 255;
  const b = Number(match[3]) / 255;
  const a = match[4] !== undefined ? Number(match[4]) : 1;

  return {
    C: [r, g, b],
    CA: a,
  };
}

export const isRgba = (color) =>
  typeof color === 'string' && color.includes('rgba(');
